<template>
  <div>
    <validation-observer ref="simpleRules">
      <params-item-form />
      <save-button
        :save-action="submitForm"
        :is-disabled="submitStatus"
      />
    </validation-observer>
  </div>
</template>
<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ParamsItemForm from '@/views/Params/ItemForm.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@core/utils/validations/validations'

export default {
  name: 'AddPage',
  components: { ValidationObserver, SaveButton, ParamsItemForm },
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['params/dataItem']
    },
    saveData() {
      return this.$store.getters['params/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.$router.push('/admin/params')
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
        this.submitStatus = false
      }
    },
  },
  created() {
    localize('tr')
    this.$store.commit('params/RESET_DATA_ITEM')
  },
  methods: {
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.$store.dispatch('params/saveData', this.dataItem)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
